export default function getQuery(obj) {
  return Object.entries(obj || {})
    .filter((f) => Boolean(f[1]))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}
